import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useResolveRootRoles } from "../../utils/hooks";

export default function EmailCampaignNav() {
  const { getRootRoles } = useResolveRootRoles();

  const items = useMemo(() => {
    const navItems = [
      {
        name: "Email Campaign",
        to: "manual-emails",
      },
      {
        name: "Scheduled Email Campaign",
        to: "send-reminder-email",
      },
      {
        name: "Auto Generated Emails",
        to: "automated-email-campaign",
      },
    ];

    return getRootRoles({
      navItems,
    });
  }, [getRootRoles]);

  return (
    <div className="dashboard-tabs innerpage-tabs px-4">
      <ul className="nav nav-tabs">
        {items.map((item, index) => (
          <li key={index} className="nav-item">
            {item?.type !== undefined ? (
              <NavLink className={`nav-link ga-nav-tab`} href={item.to}>
                {item.name}
              </NavLink>
            ) : (
              <NavLink className={`nav-link ga-nav-tab`} to={item.to}>
                {item.name}
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
